import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';

const HeaderFunctions = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingusermaser, setLoadingUsermaster] = useState(false);
  const [loadingdatasource, setLoadingDataSource] = useState(false);

  const handleLogout = async () => {
    try {
      setLoading(true);
      const token=localStorage.getItem('token');
      const response = await axios.post('http://localhost:5000/logout', {}, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.data.status === 'Sucess') {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        navigate("/", { replace: true });
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error occurred while logging out:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserMaster = async () => {
    try {
    setLoadingUsermaster(true);
    const token = localStorage.getItem('token');
    const response = await axios.get('http://localhost:5000/users', {
      headers: { 'Authorization': `Bearer ${token}` }
    });
      setLoadingUsermaster(false);
      navigate('/user-master', { state: { UserData: response.data.data } }); 
    } catch (error) {
      setLoadingUsermaster(false);
      console.error('Error occurred while fetching overview data:', error);
    }
  };

  const handleDataSource = async () => {
    try {
    setLoadingUsermaster(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('http://localhost:5000/datasource', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setLoadingDataSource(false);
      navigate('/user-master', { state: { UserData: response.data.data } }); 
    } catch (error) {
      setLoadingDataSource(false);
      console.error('Error occurred while fetching data:', error);
    }
  };

  return {
    loading,
    handleLogout,
    loadingdatasource,
    loadingusermaser,
    handleDataSource,
    handleUserMaster,
  };
};

export default HeaderFunctions;
